import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Equal: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['line', { x1: '5', x2: '19', y1: '9', y2: '9' }],
    ['line', { x1: '5', x2: '19', y1: '15', y2: '15' }],
  ],
];

export default Equal;
